import { FC } from 'react';

export type Component = (
  Component: FC<ProductConditionsProps>
) => (props: withProductConditionProps) => JSX.Element | null;

export interface withProductConditionProps {
  conditions: Sku[];
  currentCondition: Condition;
  history: HistoryType;
  parsedQs: ParsedQsType;
}

export interface ProductConditionsProps {
  showAlert: boolean;
  onlyRewrapped: boolean;
  conditionSelected: Condition;
  setConditionSelected: React.Dispatch<React.SetStateAction<Condition>>;
  parsedQs: ParsedQsType;
  history: HistoryType;
}

export interface Sku {
  offers: Offer;
  rewrapped: Offer;
}

export interface Offer {
  result: [
    {
      condition: Condition;
    }
  ];
}

export type HistoryType = {
  replace: (value: string) => void;
};

export type ParsedQsType = Record<string, string>;

export type Condition = 'new' | 'rewrapped';

export const inSkusHasConditionOfType = (skus: Sku[], condition: Condition) => {
  const place = condition === 'new' ? 'offers' : 'rewrapped';
  const hasCondition = skus?.some((sku: Sku) => sku?.[place]?.result?.[0]?.condition?.toLowerCase() === condition);

  return hasCondition;
};
